import { render, staticRenderFns } from "./ReportStock.vue?vue&type=template&id=3bc3f0c6&"
import script from "./ReportStock.vue?vue&type=script&lang=js&"
export * from "./ReportStock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports